import React from "react";
import moment from "moment";

/**
 * FacebookMessageCard - Hiển thị một tin nhắn Facebook
 * sender_type: 'customer' hoặc 'page'
 */
const FacebookMessageCard = ({
  item,
  customerName,
  customerPic,
  showTime = true,
}) => {
  const isFromCustomer = item.sender_type === "customer";

  return (
    <div
      className={`d-flex ${showTime ? "mb-2" : "mb-1"} ${
        isFromCustomer ? "" : "justify-content-end"
      }`}
    >
      {isFromCustomer && (
        <div className="mr-2">
          {customerPic ? (
            <img
              src={customerPic}
              alt={customerName}
              className="rounded-circle"
              style={{ width: 36, height: 36, objectFit: "cover" }}
            />
          ) : (
            <div
              className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white"
              style={{ width: 36, height: 36, fontSize: 14 }}
            >
              {customerName ? customerName.charAt(0).toUpperCase() : "K"}
            </div>
          )}
        </div>
      )}

      <div
        className={`message-bubble p-3 ${
          isFromCustomer ? "bg-light text-dark" : "text-white"
        }`}
        style={{
          maxWidth: "70%",
          borderRadius: isFromCustomer
            ? "0 18px 18px 18px"
            : "18px 0 18px 18px",
          backgroundColor: isFromCustomer ? "#f0f2f5" : "#0084ff",
        }}
      >
        {/* Text message */}
        {item.message_text &&
          !(
            item.attachment_type &&
            /^\[(IMAGE|VIDEO|AUDIO|FILE)\]$/i.test(item.message_text.trim())
          ) && (
            <p className="mb-0" style={{ wordBreak: "break-word" }}>
              {item.message_text}
            </p>
          )}

        {/* Attachment */}
        {item.attachment_type && item.attachment_url && (
          <div className="mt-1">
            {item.attachment_type === "image" ? (
              <img
                src={item.attachment_url}
                alt="Attachment"
                style={{ maxWidth: "100%", borderRadius: 8 }}
              />
            ) : item.attachment_type === "video" ? (
              <video
                src={item.attachment_url}
                controls
                style={{ maxWidth: "100%", borderRadius: 8 }}
              />
            ) : (
              <a
                href={item.attachment_url}
                target="_blank"
                rel="noopener noreferrer"
                className={isFromCustomer ? "text-primary" : "text-white"}
              >
                <i className="simple-icon-paper-clip mr-1" />
                Tệp đính kèm
              </a>
            )}
          </div>
        )}

        {/* Timestamp */}
        {showTime && (
          <small
            className={`d-block mt-1 ${
              isFromCustomer ? "text-muted" : "text-white-50"
            }`}
            style={{ fontSize: 11 }}
          >
            {moment(item.timestamp).format("HH:mm")}
          </small>
        )}
      </div>

      {!isFromCustomer && (
        <div className="ml-2">
          <div
            className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white"
            style={{ width: 36, height: 36, fontSize: 14 }}
          >
            <i className="iconsminds-facebook" style={{ fontSize: 18 }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default FacebookMessageCard;
